import React from 'react'
import Header from 'myPages/Header'
import './about/_style/About.css'

const About = () => (
  <div className='volo-About-navigation'>
    <Header />
    <div className='logo2' />
    <h1>About</h1>
    <div className='volo-About-about'>
      <ul className='volo-About-biography'>
        <li>
          <p><strong>ELEVATED TRAVEL. DIRECT CONNECTIONS. FULL TRANSPARENCY. TOTAL CONTROL.</strong></p>
          <p>Introducing <strong>FlyVolo.co</strong> — the future of private aviation.</p>
          <p>FlyVolo.co is the world’s first private charter jet operator index connecting customers directly to verified aircraft operators — no brokers, no hidden fees, no intermediaries. Just connect and go.</p>
          <p>Take control of your growth and revenue—maximize earnings without losing margins to broker fees.</p>
          <p>We invite all U.S. Part 135 certificated operators to join our network. No long-term commitments. Get listed in 24–48 hours.</p>
        </li>
        <li><div className='volo-About-volologo' /></li>
      </ul>
      <br />
      <h4>Why Volo? Benefits for Operators and Customers</h4>
      <ul>
        <li><h3>Receive Flight Requests Directly</h3>Our proprietary algorithm matches quote requests to your fleet and delivers them directly to your inbox with fast, transparent, competitive quotes.</li>
        <li><h3>Valuable Visibility</h3>We connect you with customers actively seeking charter access — no brokers, no markups. We handle marketing, so you can focus on operations.</li>
        <li><h3>Reach New Markets</h3>Access demand from new customer segments including executives, sports travelers, and event flyers.</li>
        <li><h3>Total Transparency</h3>Customers see real-time pricing based on your published rates with per-seat breakdowns.</li>
        <li><h3>Search by City, Not Airport</h3>Our quote engine improves routing and reduces repositioning costs by using city-based searches.</li>
      </ul>
    </div>
  </div>
)

export default About
